<template>
  <div>
    <!-- --开始------订单基本信息------------- -->
    <div class="details_content_repeat">
      <QS-h4-title title="订单基本信息" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :source="computedOrderData"
          :list="baseInfoList"
          :separator="columnSeparator"
          label-width="150"
        >
        </column-box-expand>
      </div>
    </div>
    <!-- --结束------订单基本信息------------- -->

    <!-- --开始------订单签约信息------------- -->
    <div v-if="orderType === 'personal'" class="details_content_repeat">
      <QS-h4-title title="订单签约信息" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :source="computedOrderData"
          :list="orderSigning"
          :separator="columnSeparator"
          label-width="150"
        >
        </column-box-expand>
      </div>
    </div>
    <!-- --结束------订单签约信息------------- -->

    <!-- 服务商信息------------- -->
    <div v-if="serverInfoList.length" class="details_content_repeat">
      <QS-h4-title title="服务商信息" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :source="computedOrderData"
          :list="serverInfoList"
          :separator="columnSeparator"
          label-width="150"
        >
        </column-box-expand>
      </div>
    </div>
    <!-- 服务商信息结束------------- -->

    <!--客户信息-->
    <div v-if="orderType !== 'purchaseSonOrder'" class="details_content_repeat">
      <QS-h4-title title="客户信息" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :source="computedOrderData"
          :list="customerInformation"
          :separator="columnSeparator"
          label-width="150"
        >
        </column-box-expand>
      </div>
    </div>
    <!--客户信息 结束-->

    <!--车辆信息-->
    <div class="details_content_repeat">
      <QS-h4-title title="车辆信息" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :source="computedOrderData"
          :list="ehicleInformation"
          :separator="columnSeparator"
          label-width="150"
        >
        </column-box-expand>
      </div>
    </div>

      <!--维保方案-->
    <!-- <div class="details_content_repeat">
      <QS-h4-title title="维保方案" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :source="computedOrderData"
          :list="maintenancePlan"
          :separator="columnSeparator"
          label-width="150"
        >
        </column-box-expand>
      </div>
    </div> -->

    <!--租赁信息-->
    <div class="details_content_repeat">
      <QS-h4-title title="租赁信息" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :source="computedOrderData"
          :list="leaseInfoList"
          :separator="columnSeparator"
          label-width="150"
        >
        </column-box-expand>
        <LadderScheme
          :ladderSchemeList="computedOrderData.piecewiseConfigList || {}"
          :titleList="titleList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LadderScheme from '@/pages/orders/leaseScheme/personal/components/ladderScheme.vue'
// import LadderScheme from '@/components/LadderScheme'
import { insertItemsInArrayForOrderDetail } from '@/pages/utils/overdue'

export default {
  name: 'OrderInformation',
  props: {
    computedOrderData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    LadderScheme,
  },
  data() {
    return {
      titleList: [
        {
          label: '阶梯',
          value: '',
        },
        {
          label: '起止月数',
          value: 'ladderDate',
        },
        {
          label: '租金(元)',
          value: 'amount',
        },
      ],
      orderType: '', // 用来区分是个人租赁订单详情还是企业租赁子订单详情 - 【personal】表示个人租赁订单;【enterChild】表示企业租赁子订单
      personalBaseInfoList: [ // 个人租赁订单字段
        {
          key: 'confirmTime',
          name: '订单确认时间',
        },
        {
          key: 'relatedOrderIdName',
          name: '是否关联订单',
        },
        {
          key: 'rderRelatedReasonName',
          name: '关联原因',
        },
      ],
      enterChildBaseInfoList: [ // 企业子订单字段
        {
          key: 'entRentOrderId',
          name: '企业租赁订单ID',
        },
      ],
      shareBaseInfoList: [ // 个人和企业子订单共同有的字段
        {
          key: 'id',
          name: '订单ID',
        },
        {
          key: 'stateName',
          name: '订单状态',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'outStockTime',
          name: '验车出库时间',
        },
        {
          key: 'returnCarTime',
          name: '退车发起时间',
        },
        {
          key: 'inStockTime',
          name: '验车入库时间',
        },
        {
          key: 'closeTime',
          name: '订单关闭时间',
        },
        {
          key: 'settlementStateName',
          name: '订单结算状态',
        },
      ],
      // 订单签约信息
      orderSigning: [
        {
          key: 'templateName',
          name: '合同模板',
          alone: true,
        },
        {
          key: 'signChannelName',
          name: '签约方式',
        },
        {
          key: 'contractStateName',
          name: '合同签署状态',
        },
        {
          key: 'computedContractUrl',
          name: '合同附件',
          downFile: {
            url: this.computedOrderData.computedContractUrl,
            name: '合同附件',
          },
        },
        // 【PKXW-2697】车辆-租赁管理-个人租赁订单，签约时不显示押金
        // {
        //   key: 'totalDeposit',
        //   name: '应收押金',
        //   alone: true
        //   // finance: true
        // }
      ],
      // 客户信息
      customerInformation: [
        {
          key: 'customerTypeName',
          name: '客户类型',
        },
        {
          key: 'customerId',
          name: '客户ID',
        },
        {
          key: 'customerName',
          name: '客户名称',
        },
      ],
      // 车辆信息
      ehicleInformation: [
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          // 车型ID到时候需要转
          key: 'modelName',
          name: '车型',
        },
        {
          key: 'plateNo',
          name: '绑定车辆',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'deptName',
          name: '所属部门',
        },
      ],
      // 维保方案
      /* maintenancePlan: [
        { key: 'providerName', name: '维修厂' },
        { key: 'maintenancePlanName', name: '维保方案' },
      ], */
      // 租赁信息
      // 企业子订单详情字段：方案模版名称、上架单ID、计租起止日、缴款日、赠送天数、付款形式、租金总金额/每期租金、押金、备注

      leaseInformation: [
        {
          key: 'planName',
          name: '方案模板名称',
        },
        {
          key: 'planRecordId',
          name: '上架单ID',
        },
        {
          key: 'signDate',
          name: '合同签署日期',
        },
        {
          key: 'receivablePeriod',
          name: '收款起止日',
        },
        {
          key: 'payDay',
          name: '缴款日',
        },
        {
          key: 'presentDaysName',
          name: '赠送天数',
        },
        {
          key: 'freeCycle',
          name: '免租周期',
        },
        {
          key: 'confirmWithholdState',
          name: '客户确认状态',
        },
        {
          key: 'totalAmount',
          name: '租金总金额',
          finance: true,
        },
        {
          key: 'payModeName',
          name: '租金收款方式',
        },
        {
          key: 'totalDeposit',
          name: '押金总金额',
          finance: true,
        },
        {
          key: 'remarks',
          name: '备注',
        },
        {
          key: 'rentCategory',
          name: '租赁类别',
        },
        {
          key: 'isOpen',
          name: '租赁方案性质',
        },
      ],
      // purchaseOrderData: {}, // 采购订单基本信息
    }
  },
  mounted() {
    const orderType = this.$route.query.orderType || 'personal'
    this.orderType = orderType
    if (this.orderType === 'enterChild') { // 企业租赁子订单不展示合同签署日期和客户确认状态
      const ind = this.leaseInformation.findIndex((item) => item.key === 'signDate')
      this.leaseInformation.splice(ind, 1)
      const ind2 = this.leaseInformation.findIndex((item) => item.key === 'confirmWithholdState')
      this.leaseInformation.splice(ind2, 1)
    }
    // 如果是新滞纳金收取比例则展示, 插入在租金收款方式之后
    if (this.computedOrderData.lateFeeOpen === 1) {
      this.leaseInformation = insertItemsInArrayForOrderDetail(this.leaseInformation)
    }
    this.judgePermission('driver_customer_list_detail') && this.setCustomPath()
    this.judgePermission('vehicle_list_detail') && this.setCarIdPath()
  },
  computed: {
    // 订单基本信息
    baseInfoList() {
      const baseInfo = {
        enterChild: this.shareBaseInfoList.concat(this.enterChildBaseInfoList),
        personal: this.shareBaseInfoList.concat(this.personalBaseInfoList),
        purchaseSonOrder: [
          {
            key: 'orderId',
            name: '订单ID',
          },
          {
            key: 'state',
            name: '订单状态',
          },
          {
            key: 'createDate',
            name: '订单创建时间 ',
          },
          {
            key: 'closeDate',
            name: '订单关闭时间',
          },
          {
            key: 'purchaseOrderId',
            name: '采购订单ID',
          },
          {
            key: 'returnCarDate',
            name: '退车发起时间',
          },
        ],
      }
      return baseInfo[this.orderType]
    },
    // 服务商信息
    serverInfoList() {
      const serverInfo = {
        purchaseSonOrder: [
          {
            key: 'serviceType',
            name: '服务商类型',
          },
          {
            key: 'serviceName',
            name: '服务商名称',
          },
          {
            key: 'serviceId',
            name: '服务商ID ',
          },
        ],
      }
      return serverInfo[this.orderType] || []
    },
    // 租赁信息
    leaseInfoList() {
      const leaseInfo = {
        purchaseSonOrder: [
          {
            key: 'payTimeRange',
            name: '付款起止时间',
          },
          {
            key: 'payDay',
            name: '缴款日',
          },
          {
            key: 'payTypeName',
            name: '付款形式',
          },
          {
            key: 'rentAmount',
            name: '租金总金额/每期金额',
          },
          {
            key: 'depositAmount',
            name: '押金',
          },
        ],
      }
      return leaseInfo[this.orderType] || this.leaseInformation
    },
  },
  methods: {
    // 获取采购订单基本信息
    // getOrderBaseInfo () {
    //   setTimeout(() => {
    //     this.purchaseOrderData = this.computedOrderData
    //     this.purchaseOrderData.modelName = '123456'
    //     const { startDate = '--', endDate = '--' } = this.purchaseOrderData
    //     this.purchaseOrderData.payTimeRange = startDate + '~' + endDate
    //   }, 1000);
    // }
    // 设置客户跳转路径
    setCustomPath() {
      const path = {
        path: '/driver/customerManage/detail',
        name: 'driver_customer_list_detail',
        query: {
          id: this.computedOrderData.customerId,
          customerType: this.computedOrderData.customerType,
        },
      }
      this.$set(this.customerInformation[1], 'goPage', path)
    },

    // 设置车辆ID跳转路径
    setCarIdPath() {
      const path = {
        path: '/vehicle/vehicleManage/detail',
        name: 'vehicle_list_detail',
        query: {
          id: this.computedOrderData.carId,
        },
      }
      this.$set(this.ehicleInformation[2], 'goPage', path)
    },
  },
}
</script>
